// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// --- HS Code
import {
  ParticipantRegistrationModel,
  ParticipantTokenValidationModel,
  ParticipantValidationStages,
} from '../../../models';
import { AppService } from '../app.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export abstract class ParticipantValidationBaseService {
  protected _validationStage$: BehaviorSubject<ParticipantValidationStages>;
  get validationStage$(): Observable<ParticipantValidationStages> {
    return this._validationStage$;
  }

  protected _participantValidation$: BehaviorSubject<ParticipantTokenValidationModel | null>;
  get participantValidation$(): Observable<ParticipantTokenValidationModel | null> {
    return this._participantValidation$;
  }

  protected _participantValidationError$: BehaviorSubject<string>;
  get participantValidationError$(): Observable<string> {
    return this._participantValidationError$;
  }

  protected _shouldSetSurveyPassword$: BehaviorSubject<boolean>;
  get shouldSetSurveyPassword$(): Observable<boolean> {
    return this._shouldSetSurveyPassword$;
  }

  constructor(protected appService: AppService) {
    this._validationStage$ = new BehaviorSubject<ParticipantValidationStages>(
      ParticipantValidationStages.validatingToken
    );
    this._shouldSetSurveyPassword$ = new BehaviorSubject<boolean>(false);
    this._participantValidation$ =
      new BehaviorSubject<ParticipantTokenValidationModel | null>(null);
    this._participantValidationError$ = new BehaviorSubject<string>('');
  }

  setValidationStage(stage: ParticipantValidationStages) {
    this._validationStage$.next(stage);
  }

  abstract validateParticipantToken(id: string | null, destination: string | null): void;
  abstract setPassword(setPasswordModel: ParticipantRegistrationModel): void;
}
